<template>
    <modal id="update-file-modal">
            <template slot="title">Update File Name</template>
            <template slot="body">
                <form action="#">
                    <div class="form-group">
                        <label for="title">Name</label>
                        <input type="text" name="name" v-model="form.name" class="form-control">
                    </div>
                </form>
            </template>
            <template slot="footer">
                <submit-button :form="form" @click="save()">Save</submit-button>
            </template>
    </modal>
</template>
<script>
    export default {

        props:{
            file: {
                type: Object,
                required: true,
            }
        },

        data(){
            return {
                form: new Form(this.file).dontClear()
            }
        },

        methods:{
            save(){
                this.form.patch(`/admin/files/${this.file.id}`).then(response => {
                    this.closeModal('update-file-modal')
                    Toast.success('File updated successfully!')
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            }
        },

        watch:{
            file(value){
                this.form = new Form(value).dontClear()
            }
        }
    }
</script>